import { render } from "./BaseModal.vue?vue&type=template&id=0067b5e0&scoped=true"
import script from "./BaseModal.vue?vue&type=script&lang=js"
export * from "./BaseModal.vue?vue&type=script&lang=js"

import "./BaseModal.vue?vue&type=style&index=0&id=0067b5e0&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-0067b5e0"

export default script